import { Caption } from './primitives';

/**
 * MVP2.4 T9.1 — prompt 1-clic « Tu as compris pourquoi ? » sur fail.
 *
 * Affiché inline dans la card d'échec (jamais en modal bloquante, cf.
 * DESIGN.md §5.4 : pas de pop-up bloquante pour de la simple info).
 * Le rendu suit le style Lab : 2 boutons compacts, fond glass-coral pour
 * rester dans la palette d'erreur du module concerné.
 *
 * UX kid-friendly : la question est posée 1 fois par fail, jamais sur
 * success. Les 3 success outcomes sont inférés automatiquement (temps +
 * hint) — Léon ne clique rien quand il réussit.
 */
export function UnderstandingPrompt({
  onAnswer,
  done,
}: {
  /** Appelé quand Léon clique « Oui » ou « Non ». */
  onAnswer: (understood: boolean) => void;
  /** Mis à `true` une fois la réponse envoyée — masque le prompt. */
  done: boolean;
}): JSX.Element | null {
  if (done) {
    return (
      <p className="mt-3 font-mono text-[11px] uppercase tracking-wider text-ink-300">
        Diagnostic enregistré.
      </p>
    );
  }
  return (
    <div className="mt-3 flex flex-col gap-2">
      <Caption>Tu as compris pourquoi ?</Caption>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onAnswer(true)}
          className="px-3 py-1.5 rounded-md border border-volt-500/60 bg-volt-500/10 text-volt-500 text-xs font-mono hover:bg-volt-500/20 transition-all duration-150"
        >
          Oui ✓
        </button>
        <button
          type="button"
          onClick={() => onAnswer(false)}
          className="px-3 py-1.5 rounded-md border border-coral-500/60 bg-coral-500/10 text-coral-500 text-xs font-mono hover:bg-coral-500/20 transition-all duration-150"
        >
          Non, explique-moi
        </button>
      </div>
    </div>
  );
}
